import { render, staticRenderFns } from "./BacklogPainelPage.vue?vue&type=template&id=25f1b192&scoped=true"
import script from "./BacklogPainelPage.vue?vue&type=script&lang=js"
export * from "./BacklogPainelPage.vue?vue&type=script&lang=js"
import style0 from "./BacklogPainelPage.vue?vue&type=style&index=0&id=25f1b192&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25f1b192",
  null
  
)

export default component.exports